import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Route } from 'react-router-dom';
import { Link } from 'react-router-dom'
import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react"
import {
    BsArrowRightShort
} from "react-icons/bs"
import {
    MdKeyboardArrowRight
} from "react-icons/md"
import {
    IoMdLogOut,
    IoMdArrowDropdown
} from "react-icons/io"

import { logout } from '../actions/userActions'
import Searchnav from './Searchnav';
import NavMenuItem from './NavMenuItem';
import NavMenu from './NavMenu';

const Nav = ({ history }) => {
    const Nav = useRef(null)
    const searchRef = useRef(null)
    const Buric = useRef(null)
    const navLinks = useRef(null)
    const rightItems = useRef(null)
    const [signin, setSignin] = useState(null)

    const dispatch = useDispatch()
    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    const logoutHandler = () => {
        dispatch(logout())
    }

    return (
        <nav ref={Nav}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                padding: '0 20px',
            }}
        >
            <div className="logo"><Link to=''>Skyshops</Link></div>
            {/* <div className="burger" ref={Buric} onClick={onBurgActive}>
                <div className='line1'></div>
                <div className='line2'></div>
                <div className='line3'></div>
            </div> */}
            <div className="rightComp" ref={rightItems}>
                {!userInfo && (
                    <Link to='/login' > 
                        <div className='signin' onMouseOver={() => setSignin(!signin)} onMouseOut={() => setSignin(!signin)}  > Sign in
                            {!signin ? <BsArrowRightShort size='25' /> : <MdKeyboardArrowRight size='25' />}
                        </div>
                    </Link>
                )}

                {userInfo && (
                    <Menu>
                        <MenuButton as={Button} rightIcon={<IoMdArrowDropdown />}>
                            {userInfo.name}
                        </MenuButton>
                        <MenuList>
                            <NavMenu />
                            <NavMenuItem 
                                to=''
                                onClick={logoutHandler}
                                text='Cerrar Sesión'
                                icon={<IoMdLogOut />}
                            />
                        </MenuList>

                    </Menu>
                )}

            </div>
        </nav>
    )
}
export default Nav                      